module.exports = __webpack_public_path__ + "img/costal-8-1.59308b93.jpg";